<template>
  <div>
    <div class="flex items-center justify-start">
      <icon-base
        height="24"
        width="24"
        :icon="`${model.mime_type.includes('image') ? 'img' : fileType}-small`"
      />

      <document-preview-modal
        v-if="showModal"
        :item="model"
        :close="() => (showModal = false)"
      />

      <span
        :title="model.original_name"
        class="ml-4 cursor-pointer text-base text-gray-600 hover:text-gray-400"
        @click="showModal = true"
      >
        {{ model.original_name }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import { getDocumentFileType } from "@/helpers/formatting";

import DocumentPreviewModal from "./DocumentPreviewModal.vue";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
});

const showModal = ref(false);

const fileType = computed(() => getDocumentFileType(props.model.original_name));
</script>
